module.exports = __webpack_public_path__ + "static/media/img-10.cf750257.jpg";